"use client";

import { createContext, FC, PropsWithChildren, ReactNode } from "react";
import { INotificationState } from "hooks";
import { TranslationScopes } from "@finbackoffice/enums";
import classNames from "classnames";
import SiteNotification from "components/base/notification/SiteNotification";
import Translate from "components/base/translate/Translate";
import { useCollapseMargin } from "@finbackoffice/site-core";
import styles from "./account-details-form-block.module.sass";

interface IProps {
    wrapperClassname?: string;
    renderHeader: (isOpened?: boolean) => string | ReactNode;
    testId?: string;
    notification?: INotificationState;
    defaultOpened?: boolean;
    disableCollapse?: boolean;
}

type IAccountDetailsFormBlockContext = PropsWithChildren<IProps>;

export const AccountDetailsFormBlockContext = createContext<IAccountDetailsFormBlockContext>(
    null as any,
);

const AccountDetailsFormBlock: FC<PropsWithChildren<IProps>> = ({
    wrapperClassname,
    renderHeader,
    children,
    testId,
    notification,
    defaultOpened,
    disableCollapse,
}) => {
    const { opened, animating, headerRef, containerRef } = useCollapseMargin(
        defaultOpened || false,
        400,
    );

    const labelMemo = renderHeader(opened);

    return (
        <div
            className={classNames(styles.infoForm, opened && styles.opened, wrapperClassname)}
            data-testid={testId}>
            <div className={styles.header} ref={disableCollapse ? null : headerRef}>
                <div className={styles.blockName}>
                    {typeof labelMemo === "string" ? (
                        <span>
                            <Translate tid={labelMemo} namespace={TranslationScopes.UserAccount} />
                        </span>
                    ) : (
                        labelMemo
                    )}
                </div>
            </div>
            {(opened || animating) && (
                <div ref={containerRef}>
                    {children}
                    {notification?.type && (
                        <SiteNotification
                            type={notification.type}
                            title={notification.error}
                            message={notification.message}
                            wrapperClassname={styles.userInfoNotification}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default AccountDetailsFormBlock;
